import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/*
 * A queue for redux thunks (see https://github.com/reduxjs/redux-thunk).
 *
 * Use this if you need to ensure that asynchronous actions happen in series.
 * This can be useful to avoid race conditions.
 *
 * Example:
 *
 *     const queue = new ThunkQueue()
 *     const action = queue.wrapActionCreator((...args) => {
 *       return (dispatch, getState) => {
 *         ...
 *       }
 *     })
 *
 * If a thunk fails, all pending thunks will be cancelled and will not run.
 * You can pass an error handler to the constructor:
 *
 *     const queue = new ThunkQueue((error, dispatch, getState) => { ... })
 *
 * This error handler will be called for every thunk that fails. This can be
 * useful if, for example, you are using a queue to ensure that API calls are
 * processed in sequence with optimistic UI updates, and want to reset the UI
 * to match backend state if a request fails.
 */
var ThunkQueue = /*#__PURE__*/function () {
  function ThunkQueue() {
    var errorHandler = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    _classCallCheck(this, ThunkQueue);
    this.errorHandler = errorHandler;
    this.queue = [];
  }
  return _createClass(ThunkQueue, [{
    key: "wrapActionCreator",
    value: function wrapActionCreator(fn) {
      var _this = this;
      return function () {
        return _this.wrapThunk(fn.apply(void 0, arguments));
      };
    }
  }, {
    key: "wrapThunk",
    value: function wrapThunk(action) {
      var _this2 = this;
      if (typeof action !== 'function') {
        return action;
      }
      return function (dispatch, getState) {
        var promise = _this2._run(action, dispatch, getState);
        // Attach a reference to the thunk on the promise so we can cancel it if
        // an earlier promise fails
        promise.thunk = action;
        _this2.queue.push(promise);
        return promise;
      };
    }
  }, {
    key: "_run",
    value: function () {
      var _run2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(thunk, dispatch, getState) {
        var _iterator, _step, promise;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.all(this.queue);
            case 2:
              _context.prev = 2;
              if (!thunk.cancelled) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              _context.next = 7;
              return thunk(dispatch, getState);
            case 7:
              return _context.abrupt("return", _context.sent);
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              // If this thunk fails, cancel all pending thunks
              _iterator = _createForOfIteratorHelper(this.queue);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  promise = _step.value;
                  promise.thunk.cancelled = true;
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              if (!this.errorHandler) {
                _context.next = 18;
                break;
              }
              return _context.abrupt("return", this.errorHandler(_context.t0, dispatch, getState));
            case 18:
              throw _context.t0;
            case 19:
              _context.prev = 19;
              this.queue.shift();
              return _context.finish(19);
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 10, 19, 22]]);
      }));
      function _run(_x, _x2, _x3) {
        return _run2.apply(this, arguments);
      }
      return _run;
    }()
  }]);
}();
export { ThunkQueue as default };